const envBase = (process.env.REACT_APP_API_BASE_URL || '').trim();
const LEGACY_BASE = 'http://localhost:3001';

function computeFallbackBase() {
  if (typeof window !== 'undefined' && window.location) {
    return `${window.location.protocol}//${window.location.host}`;
  }
  return LEGACY_BASE;
}

const normalizedBase = (envBase || computeFallbackBase()).replace(/\/$/, '');

export const API_BASE_URL = normalizedBase;

export const replaceLegacyBase = (value = '') => {
  if (typeof value !== 'string') return value;
  if (value.startsWith(LEGACY_BASE)) {
    return `${API_BASE_URL}${value.slice(LEGACY_BASE.length) || ''}` || API_BASE_URL;
  }
  return value;
};

export const apiUrl = (path = '') => {
  if (!path) return API_BASE_URL;
  const hasProtocol = /^https?:\/\//i.test(path);
  if (hasProtocol) return path;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};

export const resolveUploadsPath = (maybePath = '') => {
  if (!maybePath) return '';
  return apiUrl(maybePath);
};

export const isApiUrl = (url = '') => {
  if (typeof url !== 'string' || !url) return false;
  if (url.startsWith('/api') || url.startsWith('/uploads')) return true;
  const normalized = replaceLegacyBase(url);
  return normalized.startsWith(`${API_BASE_URL}/api`) || normalized.startsWith(`${API_BASE_URL}/uploads`);
};
